import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApi } from '../RestApi/restApi';


interface MigrationConfigComponentinfo {
  statusMessage: any,
  error: boolean,
  data: any
}

@Injectable({
  providedIn: 'root'
})
export class MigrationConfigComponentServices {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi
  ) { }

  insertMigrationConfigComponentinfoData(vaultObject,flag){
    return this.http.post<MigrationConfigComponentinfo>(this.restAPI.insertMigrationCongifration +'/'+flag,JSON.stringify(vaultObject),{ headers: this.headers })
  }
  updateMigrationConfigComponentinfoData(vaultObject,flag){
    return this.http.post<MigrationConfigComponentinfo>(this.restAPI.insertMigrationCongifration +'/'+flag,JSON.stringify(vaultObject),{ headers: this.headers })
  }

  retreiveMigrationConfigComponentinfoData() {
    return this.http.get<MigrationConfigComponentinfo>(this.restAPI.RetriveMigrationCongifration, { headers: this.headers })
  }

  DeleteFromMigrationConfigComponentinfoData(vaultObject) {
    return this.http.post<MigrationConfigComponentinfo>(this.restAPI.deleteFromMigrationCongifration,JSON.stringify(vaultObject), { headers: this.headers })
  }
  

  // Below code for Test Bed
  retreiveMappingtestbedRecordWithmigrationid() {
    return this.http.get<MigrationConfigComponentinfo>(this.restAPI.RetriveMigrationtestbed, { headers: this.headers })
  }

  retreiveMappingtestbedRecord(MigrationId){
    return this.http.get<MigrationConfigComponentinfo>(this.restAPI.RetriveMigrationtestbed+'/'+MigrationId, { headers: this.headers })
  }

  MappingtestbedInsertRcord(insertObject) {
    return this.http.post<MigrationConfigComponentinfo>(this.restAPI.insertMigrationtestbed,JSON.stringify(insertObject), { headers: this.headers })
  }

  DeleteFromtestbed(mappingtestbedid) {
    return this.http.post<MigrationConfigComponentinfo>(this.restAPI.deleteFromMigrationtestbedbasedonMigrationid+'/'+mappingtestbedid, { headers: this.headers })
  }
  

  retrieveValuesForMappingtestbedAndTraceBaedonMigrationid(Migrationid){
    return this.http.get<MigrationConfigComponentinfo>(this.restAPI.RetriveMigrationtestbedBasedOnMigrationId+'/'+Migrationid, { headers: this.headers })
  }

  retrivemappingtestbedforattribute(){
    return this.http.get<MigrationConfigComponentinfo>(this.restAPI.retrivemappingtestbedforattribute, { headers: this.headers })
  }

  uploadfile(formData){
    return this.http.post(this.restAPI.uploadfile,formData)
  }


 // Below code for TestBed Execution
 insertintotestbedexecution(mappingtestbedid,attributesIds,WorkspaceId,screenName,reverifyStage){
    return this.http.post<MigrationConfigComponentinfo>(this.restAPI.insertIntoTestBedExecution+'/'+mappingtestbedid+"/"+attributesIds+"/"+WorkspaceId+"/"+screenName+"/"+reverifyStage, { headers: this.headers })
 }

 retriveJsonData(attributesIds,WorkspaceId,flag){
  return this.http.get<MigrationConfigComponentinfo>(this.restAPI.retriveJsonData+'/'+attributesIds+"/"+WorkspaceId+"/"+flag, { headers: this.headers })
 }
}
 